<template>
  <div id="articles">
    <section class="articles">
      <div class="container">
        <!-- 標題 -->
        <div class="articles-header">
          <router-link
            :to="{name: 'activities', params:{id:$route.params.id}}"
            class="text-primary d-inline-flex align-items-center pr-3"
          >
            <i class="material-icons">arrow_left</i>
            <strong>BACK</strong>
          </router-link>
        </div>
        <main>
          <h1 class="h4 text-secondary">{{articles.title}}</h1>
          <p
            v-if="articles.subtitle"
            class="h5 text-secondary-light subtitle"
            :class="{'pb-20':articles.subtitle!==''}"
          >{{articles.subtitle}}</p>
          <p
            class="py-10 d-flex align-items-center"
            v-if="articles.publish_at || articles.publisher"
          >
            <i class="material-icons text-primary">stop</i>
            <span>{{articles.publish_at}}</span>
            <span class="ml-auto">{{articles.publisher || ''}}</span>
          </p>
          <!-- video -->
          <iframe
            v-if="articles.youtube!==''"
            :src="videoID"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="width: 100%; margin-top: 40px; margin-bottom: 40px;"
            :style="iframeStyle"
          ></iframe>
          <article>
            <h6 v-if="articles.brief" class="text-secondary-light">{{articles.brief}}</h6>
            <!-- one-image -->
            <div
              v-if="media.length===1"
              class="one-img bg-secondary w-100"
              v-lazy:background-image="media[0].medium"
              :key="media[0].id"
            ></div>
            <!-- multi-image -->
            <hooper
              v-if="media.length>1"
              group="group1"
              class="large p-0 m-0"
              :itemsToShow="1"
              :wheelControl="true"
              :keysControl="true"
              :infiniteScroll="true"
            >
              <slide
                v-for="(item, index) in media"
                :key="index"
                class="d-flex align-items-center justify-content-center"
              >
                <img v-lazy="item.medium" :key="item.id" />
              </slide>
            </hooper>
            <hooper
              v-if="media.length>1"
              group="group1"
              class="list p-0 m-0 mt-10"
              :itemsToShow="3"
              :wheelControl="true"
              :keysControl="true"
              :infiniteScroll="true"
              :centerMode="true"
            >
              <slide
                v-for="(item, index) in media"
                :key="index"
                class="d-flex align-items-center justify-content-center"
              >
                <img v-lazy="item.medium" :key="item.id" />
              </slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>

            <div class="content" v-html="articles.content"></div>
          </article>
        </main>
      </div>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';

export default {
  name: 'articles',
  metaInfo: {
    title: ' - 活動紀錄',
  },
  data() {
    return {
      articles: {},
      videoID: '',
      iframeStyle: {
        height: '500px',
      },
    };
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
  computed: {
    media() {
      return this.articles.media ? this.articles.media.data : [];
    },
    // content() {
    //   return this.articles.content.replace(new RegExp('pre', 'ig'), 'div');
    // },
  },
  methods: {
    getArticle() {
      const loading = this.$loading.show({
        'is-full-page': true,
      });
      const url = `/article/${this.$route.params.id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.articles = response.data.data;
          if (this.articles.youtube !== '') {
            const id = this.articles.youtube.includes('http')
              ? this.articles.youtube.split('be/')[1]
              : this.articles.youtube;
            this.videoID = `https://www.youtube.com/embed/${id}`;
          }
          if (this.articles.content.match(/^pre/g) !== undefined) {
            this.articles.content = this.articles.content.replace(new RegExp('pre>', 'ig'), 'div>');
          }
          loading.hide();
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          loading.hide();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getArticle();
    setTimeout(() => {
      this.scrollToTop();
    }, 500);
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/all.scss';
#articles {
  @media (min-width: 576px) {
    background-image: url('~@/assets/images/bg-circle-left.svg'),
      url('~@/assets/images/bg-circle-right.svg');
    background-size: 170px auto, 170px auto;
    background-repeat: repeat-y, repeat-y;
    background-position: left top, right top;
  }
  section:not(.hooper) {
    min-height: 450px;
    padding: 20px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    &.articles {
      padding-bottom: 50px;
      .articles-header {
        position: relative;
        a {
          font-size: 15px;
          background-color: #fff;
          z-index: 1;
          text-decoration: none;
          i {
            font-size: 40px;
          }
          &::before {
            content: '';
            position: absolute;
            background-color: $primary;
            left: 0;
            right: 0;
            top: 19px;
            height: 4px;
            z-index: -1;
          }
        }
      }
      main {
        padding: 0 20px;
        @media (min-width: 992px) {
          padding: 0 80px;
        }
        margin: 20px auto;
        background-color: rgba(255, 255, 255, 0.8);
        h1 {
          padding-bottom: 20px;
          font-weight: 700;
        }
        .subtitle {
          border-bottom: 2px dashed $secondary-white;
        }
        .one-img[lazy='loading'] {
          background-position: center center;
          background-size: 64px 64px;
          background-repeat: no-repeat;
          background-color: $secondary-white;
          border-radius: 5px;
          height: 600px;
          margin: 40px 0;
        }
        .one-img[lazy='loaded'] {
          background-position: center center;
          background-size: cover;
          border-radius: 5px;
          height: 600px;
          margin: 40px 0;
        }
        article {
          color: $secondary;
          letter-spacing: 1px;
          line-height: 2em;
          h6 {
            padding-bottom: 20px;
            border-bottom: 2px dashed $secondary-white;
            line-height: 1.75em;
          }
          .content {
            padding: 20px 0;
          }
          .icon:not(svg) {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-color: $primary;
          }
        }
      }
    }
  }
  section.hooper {
    &.large {
      height: 350px;
      @media (min-width: 576px) {
        height: 500px;
      }
      @media (min-width: 992px) {
        height: 600px;
      }
      overflow: hidden;
      li {
        width: 100%;
        overflow: hidden;
      }
      img {
        height: 100%;
        width: auto;
        @media (min-width: 576px) {
          width: 100%;
          height: auto;
        }
      }
    }
    &.list {
      height: 120px;
      @media (min-width: 992px) {
        height: 200px;
      }
      li {
        border: 1px solid white;
        width: 100%;
        overflow: hidden;
      }
      img {
        height: 100%;
        width: auto;
        @media (min-width: 992px) {
          width: 100%;
          height: auto;
        }
      }
    }
    .hooper-navigation {
      button {
        background: rgba(0, 0, 0, 0.5);
      }
      svg {
        path:nth-of-type(2) {
          fill: white;
        }
      }
    }
  }
  img[lazy='loading'] {
    width: 200px;
    height: 200px;
  }
}
</style>
